import { LayerKind, type PlanLayers } from "@/shared/plan";

/** Марки каталоговых объектов на листах экспорта: одинаковы на плане и в ведомости. */
export const exportObjectMarks = (
	layers: PlanLayers,
	markedLayers: readonly LayerKind[] = [],
): ReadonlyMap<string, string> => {
	const marks = new Map<string, string>();
	const addLayer = (
		prefix: string,
		layer: { items: Record<string, unknown>; fixtures: Record<string, unknown> },
	) => {
		let index = 1;
		for (const id of [...Object.keys(layer.items), ...Object.keys(layer.fixtures)]) {
			marks.set(id, `${prefix}${index}`);
			index += 1;
		}
	};
	if (markedLayers.includes(LayerKind.Electrical)) addLayer("ЭЛ", layers.electrical);
	if (markedLayers.includes(LayerKind.Plumbing)) addLayer("САН", layers.plumbing);
	if (markedLayers.includes(LayerKind.Furniture)) addLayer("МЕБ", layers.furniture);
	return marks;
};
